import { t } from 'i18next';

import { DataTableCellProps, TableCell } from 'components/dataTable';
import IconAdd from 'components/icons/add';
import IconDash from 'components/icons/dash';

import { CustodialWalletTransactionType } from 'types/custodialWallet';

import { LABELS } from '../../keys';
import { isRefundMovement } from '../../utils';
import { Movement, Primary, Secondary } from './styles';

const refundMovementIcon = (
  <Secondary>
    <IconDash />
  </Secondary>
);

export const TypeCell = ({ className, row, column }: DataTableCellProps & { className?: string }) => {
  const value = row[column.id] as CustodialWalletTransactionType;

  const icon = isRefundMovement(value)
    ? refundMovementIcon
    : {
        [CustodialWalletTransactionType.MerchantTopup]: (
          <Primary>
            <IconAdd />
          </Primary>
        ),
        [CustodialWalletTransactionType.Charge]: null,
        [CustodialWalletTransactionType.Payout]: null,
        [CustodialWalletTransactionType.TransferFromSettlementWallet]: null,
        [CustodialWalletTransactionType.TransferToRefundWallet]: null,
      }[value];

  const label = t(LABELS.TRANSACTION_TYPE_LABELS[value]);

  const formattedValue = (
    <Movement>
      {icon} {label}
    </Movement>
  );

  return (
    <TableCell className={className} data-column={column.id}>
      {formattedValue}
    </TableCell>
  );
};
